module.exports = __webpack_public_path__ + "back-end-services.1uHotR5m.svg";